import type { FieldsGroupRestrictionDTO } from '@/api/base/DTOs';
import type { FieldsGroupRestrictionPayload } from '@/forms/typings';

/** Maps a group restriction DTO to its FormField payload, or undefined when no rule applies. */
export const adaptFieldsGroupRestrictionResponse = (
  restriction: FieldsGroupRestrictionDTO | undefined,
): FieldsGroupRestrictionPayload | undefined => {
  if (!restriction) return undefined;

  const payload: FieldsGroupRestrictionPayload = {};

  if (restriction.atLeastOneChildWithValue) {
    payload.atLeastOneChildWithValue = {
      message: restriction.atLeastOneChildWithValue.message,
      treatNotApplicableAsValue:
        restriction.atLeastOneChildWithValue.treatNotApplicableAsValue,
      childItemIDs:
        restriction.atLeastOneChildWithValue.childItemIDs ?? undefined,
      hint: restriction.atLeastOneChildWithValue.hint,
    };
  }

  if (restriction.atLeastOneChildAnsweredYes) {
    payload.atLeastOneChildAnsweredYes = {
      message: restriction.atLeastOneChildAnsweredYes.message,
    };
  }

  if (restriction.requiredWhenValue) {
    payload.requiredWhenValue = {
      message: restriction.requiredWhenValue.message,
      requiredFieldItemID: restriction.requiredWhenValue.requiredFieldItemID,
      whenItemID: restriction.requiredWhenValue.whenItemID,
      whenBoolEquals: restriction.requiredWhenValue.whenBoolEquals,
    };
  }

  if (restriction.limitPairs?.pairs?.length) {
    payload.limitPairs = {
      pairs: restriction.limitPairs.pairs.map(pair => ({
        lowerItemID: pair.lowerItemID,
        upperItemID: pair.upperItemID,
        unlimitedItemID: pair.unlimitedItemID,
        comparisonMessage: pair.comparisonMessage,
        requiredMessage: pair.requiredMessage,
        lowerMinimum: pair.lowerMinimum,
        upperMinimum: pair.upperMinimum,
      })),
    };
  }

  return Object.keys(payload).length > 0 ? payload : undefined;
};
